import type { AgentMessage, AgentRequestMessage, AgentsMessage } from '../../../../types/AgentMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';
import { nonEmpty } from '../paramUtils';

interface CreateAgentParams {
    agent: AgentRequestMessage;
}

export const createAgent = async ({ agent }: CreateAgentParams): Promise<AgentMessage> => {
    const response = await authorizedAxiosInstance.post('/v1/agents', agent);

    return response.data;
};

interface UpdateAgentParams {
    agentId: string;
    agent: AgentRequestMessage;
}

export const updateAgent = async ({ agent, agentId }: UpdateAgentParams): Promise<AgentMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/agents/${agentId}`, agent);

    return response.data;
};

export interface GetAgentListParams {
    ids?: string[];
    portIds?: string[];
    customerIds?: string[];
    searchQuery?: string;
}

export const getAgentList = async ({
    ids,
    searchQuery,
    portIds,
    customerIds,
}: GetAgentListParams): Promise<AgentsMessage> => {
    const response = await authorizedAxiosInstance.get('/v1/agents', {
        params: {
            ids: nonEmpty(ids?.join(',')),
            portIds: nonEmpty(portIds?.join(',')),
            customerIds: nonEmpty(customerIds?.join(',')),
            searchQuery: searchQuery?.trim() || undefined,
            active: true,
        },
    });

    return response.data;
};
